import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { factoriesForCurrentUserSelector, devicesSelector, itemsSelector } from '../selectors';
import ComponentType from '../components/SettingDashboard/ComponentType';
import { closeModal, createComponent, updateComponent } from '../actions/entry';

const mapStateToProps = ({ componentCreateForm: { data: component, isSubmitting } }) => {
  return (state) => {
    const factories = factoriesForCurrentUserSelector(state);
    const devices = devicesSelector(state);
    const items = itemsSelector(state);
    return {
      factories,
      devices,
      items,
      component,
      isSubmitting,
    };
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onCreate: (data) => createComponent(data.type, data),
      onUpdate: (data) => updateComponent(data.type, data.id, data),
      onClose: closeModal,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(ComponentType);
